const mediaBase = 'https://a1media.antena1.com.br/image/news';

const newsImage = (news, featured = false) => {
    const isBanner = featured && !!news.featuredImage;
    const dimensions = isBanner
        ? ['576x240', '768x320', '992x413', '1920x800']
        : ['320x168', '482x250', '560x292', '752x392', '1024x536'];
    const file = isBanner ? news.featuredImage : news.imageNew;
    const [width, height] = (isBanner ? '576x240' : '482x250').split('x').map(Number);

    if (news.imageUrl) return { src: news.imageUrl, width, height };

    if (!file) {
        const legacyImage = news.oldImage || news.image;

        return {
            src: legacyImage ? `${mediaBase}/${encodeURI(legacyImage)}` : '/thumbnail_Default.jpg',
            width,
            height,
        };
    }

    const encoded = encodeURI(file);
    const canOptimize = /\.(png|jpe?g)$/i.test(file) && !/[\\/]/.test(file)
        && [...file].every((character) => character.charCodeAt(0) >= 32 && character.charCodeAt(0) !== 127);
    const revision = encodeURIComponent(news.updateDate || news.date || '1');
    const webpUrl = (size) => `https://a1media.antena1.com.br/webp.php?size=${size}&file=${encodeURIComponent(file)}&v=${revision}`;

    return {
        src: `${mediaBase}/${width}x${height}/${encoded}`,
        srcSet: dimensions.map((size) => `${mediaBase}/${size}/${encoded} ${size.split('x')[0]}w`).join(', '),
        ...(canOptimize ? { webpSrcSet: dimensions.map((size) => `${webpUrl(size)} ${size.split('x')[0]}w`).join(', ') } : {}),
        width,
        height,
    };
};

export default newsImage;
